module.exports = __webpack_public_path__ + "img/submitted-review.2735dea9.png";